<template>
  <div class="row ml-0">
    <div class="col">
          <input
            class="form-control search-input filter-border-bottom"
            name="reservation-id"
            v-model="filterProps.reservationId"
            type="text"
            :placeholder="
              $t('reservations.bookings.list.search.reservation-id-placeholder')
            "
          />
      </div>
      <div class="col">
        <input
          class="form-control search-input filter-border-bottom"
          name="reservation-title"
          v-model="filterProps.title"
          type="text"
          :placeholder="$t('reservations.bookings.list.search.title')"
        />
      </div>
      <div class="col">
        <label><input
          name="reservation-title"
          v-model="filterProps.actionDate"
          type="checkbox"
        /> Action dates</label>
      </div>
      <div class="col-1 text-right">
        <button @click="resetForm" class="btn btn-sm btn-primary">
          {{ $t('reservations.bookings.list.search.reset-form') }}
        </button>
      </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      assignmentOptions: [],
      resetFormKey: false,
      paymentStatuses: [],
      reservationStatuses: {},
      reservationStatusesOrigin: [],
      filterProps: {
        reservationId: '',
        title: ''
      }
    }
  },
  watch: {
    filterProps: {
      handler () {
        this.debouncedSearch()
      },
      deep: true,
      immediate: false
    }
  },
  created: function () {
    this.debouncedSearch = this.$_.debounce(this.prepareAndEmitFilters, 500)
  },
  mounted: function () {
    this.debouncedSearch()
  },
  props: ['reservationStatusCode'],
  methods: {
    resetForm () {
      this.filterProps = {
        reservationId: '',
        title: ''
      }
      this.resetFormKey = !this.resetFormKey
    },
    prepareAndEmitFilters () {
      let filters = []
      const copiedFilters = { ...this.filterProps }
      Object.keys(copiedFilters).forEach(filterProp => {
        if (copiedFilters[filterProp]) {
          let f = {
            property: `${filterProp}`,
            value: `${copiedFilters[filterProp]}`
          }
          filters.push(f)
          if (filterProp === 'actionDate') {
            // action dates shoul be found only in reservations marked as auto booked
            filters.push({
              property: `autoBooking`,
              value: true
            })
            // non-equal filter for STOPPED status
            filters.push({
              property: `autoBookingStatus`,
              value: 'STOPPED'
            })
          }
        }
      })
      this.$emit('filtersUpdated', filters)
    }
  }
}
</script>
<style lang="scss" scoped>
select.input-group {
  border-bottom: 1px solid #dddddd;
  border-radius: 0;
  padding: 6px;
}

.light-background {
  .right-chevron {
    line-height: 35px;
  }
  background-color: #f7fafc;
}

/deep/ .vc-shadow {
  border: none;
  background-color: #f7fafc;
  box-shadow: none;
  color: #008cdd;
  font-family: 'Open Sans Semibold';
  font-size: 14px;
}

.payment-status-selection,
.assignment-option-selection {
  font-family: 'Open Sans Italic';
  font-size: 12px;
  border-bottom: 1px solid #dddddd;
  line-height: 26px;
  border-bottom: 1px solid #dddddd;
  border-radius: 0;
  padding-left: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/search/ReservationLine.vue